import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

const TABLE_STYLES = 'flex flex-col border-none'

export const Table: React.FC<PropsWithChildren> = ({ children }) => (
  <table className={TABLE_STYLES}>
    <tbody className="flex flex-col">{children}</tbody>
  </table>
)

interface Width {
  width?: string
}

const SHARED_STYLES =
  'flex flex-col flex-grow flex-shrink border-0 bg-transparent my-auto mx-0 p-2 font-body text-left'

interface CellProps extends Width {
  colSpan?: number
  className?: string
}

const CELL_STYLES = `${SHARED_STYLES} text-body text-sm`

export const Cell: React.FC<PropsWithChildren<CellProps>> = ({
  width,
  className,
  colSpan,
  children,
}) => (
  <td
    colSpan={colSpan}
    className={concatStyles(CELL_STYLES, className)}
    style={{ width: width ?? 'auto', flexBasis: width ?? 'auto' }}
  >
    {children}
  </td>
)

interface HeaderProps extends CellProps {}

const HEADER_STYLES = `${SHARED_STYLES} text-white bg-secondary text-sm`

export const Header: React.FC<PropsWithChildren<HeaderProps>> = ({
  width,
  className,
  children,
}) => (
  <th
    className={concatStyles(HEADER_STYLES, className)}
    style={{ width: width ?? 'auto', flexBasis: width ?? 'auto' }}
  >
    {children}
  </th>
)

const ROW_STYLES =
  'flex flex-row border-0 min-h-13 first:min-h-8 odd:bg-contentareabackgroundalt even:bg-altrow'

export const Row: React.FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => <tr className={concatStyles(className, ROW_STYLES)}>{children}</tr>
